exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-travel-list-proposals {\n  overflow: hidden;\n}\n.dyna-travel-list-proposals--product-IM_HOLIDAY {\n  background-color: #382F2D;\n  color: #101820;\n}\n.dyna-travel-list-proposals--product-DIE_TO_FLY {\n  background-color: #D22630;\n  color: #101820;\n}\n.dyna-travel-list-proposals__filters {\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n", ""]);

// exports
